import { useEffect, useRef, useState } from 'react';
import './index.less'
import { getViewQuestions, getViewVideos, deleteSignleRecord } from '@/api/user'
import { useNavigate } from 'react-router-dom'
import { getVideoListMenu } from "@/api/videoPlay";
import { Empty, Modal, Pagination } from 'antd';
import VideoDetail from '../../../videoPlayer/components/videoDetail'
import useThumbsUp from '../../hooks/useThumbsUp';

const BrowseRecords = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { handleThumbsUp } = useThumbsUp();
  const navigate = useNavigate();
  const videoUrl = useRef<string>("");
  const [pageNumber, setPageNumber] = useState(0);
  const [total, setTotal] = useState(0);
  const [showVideoPlayer, setShowVideoPlayer] = useState<boolean>(false);
  const tabs = [
    {
      label: '问答',
      value: 'question',
      api: getViewQuestions
    },
    {
      label: '视频',
      value: 'video',
      api: getViewVideos
    }
  ]
  const [activeTab, setActiveTab] = useState('question');
  const [questionList, setQuestionList] = useState([])
  const [videoList, setVideoList] = useState([])
  const viewDetail = (sourceId: string, type: 'UGC' | 'FAQ') => {
    const typeMap = {
      UGC: 'feedback',
      FAQ: 'faq'
    };
    navigate(`/technicalSupport/${typeMap[type]}Detail/${sourceId}`);
  }
  const getBrowseRecords = async(page: number) => {
    try {
      const API = tabs.find(item => item.value === activeTab)?.api
      const res: any = await API?.({
        pageNumber: page,
        pageSize: 5
      })
      if (res?.code === 200) {
        activeTab === 'question' ? setQuestionList(res.result.records) : setVideoList(res.result.records);
        setTotal(res.result.total);
        setPageNumber(res.result.current);
      }
    } catch (error) {
      console.log(error)
    }
  }
  const handleDelete = (sourceId: string) => {
    modal.confirm({
      title: '提示',
      content: '确认删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        const res = await deleteSignleRecord(sourceId)
        if (res.code === 200) {
          window.message.success('删除成功', 2);
          const list = [...questionList];  
          const index = list.findIndex((item: any) => item.sourceId === sourceId);
          list.splice(index, 1)
          setQuestionList(list);
          setTotal(total - 1);
        }
      }
    })
    
  }
  const paginationChange = (page: number) => {
    getBrowseRecords(page);
  }
  useEffect(() => {
    getBrowseRecords(1)
  }, [activeTab])
  const jumpUrl = (id: any) => {
    // 判断当前视频 child 否仅有一条
    getVideoListMenu({
      id,
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res.result);
        if (res.result.children.length === 1) {
          videoUrl.current = res.result?.children?.[0]?.videoUrl;
          setShowVideoPlayer(true);
        } else {
          navigate(`/videoCollection?id=${id}`);
        }
      }
    });
  };
  return <div className="browse-records">
    {contextHolder}
    <div className="browse-records-title">浏览记录</div>
    <div className="browse-records-blocks">
      {tabs.map(item => {
        return <span 
            className={`block-item ${activeTab === item.value ? 'active' : ''}`} 
            key={item.value} 
            onClick={() => {
              setActiveTab(item.value);
              setPageNumber(1);
            }}
          >
            {item.label}
          </span>
      })}
    </div>
    {
      activeTab === 'question' && questionList.length > 0 && <div className='browse-records-question'>
        {
          questionList.map((item: any) => {
            return <div className='question-item' key={item.sourceId}>
              <div onClick={() => viewDetail(item.sourceId, item.type)}>{item.title}</div>
              <div>
                <span>{item.browseTime} 看过</span>
                <div className='operate-box'>
                  <span onClick={() => handleThumbsUp(item.type, item.sourceId, item.currentUserIsThumbsUp, setQuestionList)}>
                    <img src={item.currentUserIsThumbsUp ? require('@/assets/images/support/avport.png') : require('@/assets/images/support/no-avport.png')} alt="" />
                    {item.thumbsUpCount}
                  </span>
                  <span>
                    <img src={require('@/assets/images/support/look.png')} alt="" />
                    {item.viewCount}
                  </span>
                  <span>
                    <img src={require('@/assets/images/icon-more.png')} alt="" />
                    <span className='cancel-question' onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(item.sourceId);
                    }}>删除</span>
                  </span>
                </div>
              </div>
            </div>
          })
        }
      </div>
    }
    {
      ((activeTab === 'question' && questionList.length === 0) || (activeTab === 'video' && videoList.length === 0)) && <div className="empty-content">
        <Empty description="暂无数据" />
      </div>
    }
    {activeTab === 'video' && videoList.length > 0 && <div className='browse-records-video'>
      {
        videoList.map((item: any) => {
          return <div className='video-item' key={item.id} onClick={() => jumpUrl(item.sourceId)}>
            <div className='video-item-img'>
              <img src={item.image} alt="" />
            </div>
            <div className='video-item-title' title={item.title}>{item.title}</div>
            <div className='video-item-content'>{item.categoryDescribe}</div>
            <div className='video-item-time'>{item.browseTime}</div>
          </div>
        })
      }
    </div>}
    {showVideoPlayer && (
        <Modal
          open={showVideoPlayer}
          maskClosable={false}
          closable={false}
          onCancel={() => {
            setShowVideoPlayer(false);
          }}
          onOk={() => setShowVideoPlayer(false)}
          wrapClassName="video-player-model"
        >
          <VideoDetail close={() => setShowVideoPlayer(false)} url={videoUrl.current} />
        </Modal>
      )}
      {
        ((activeTab === 'question' && total > questionList.length) || (activeTab === 'video' && total > videoList.length)) && <Pagination
          pageSize={5}
          current={pageNumber}
          showSizeChanger={false}
          total={total}
          rootClassName="pagination"
          onChange={paginationChange}
        />
      }
  </div>
}

export default BrowseRecords;